module.exports = __webpack_public_path__ + "static/img/2.0fd4e08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/2.png
// module id = Cd2i
// module chunks = 0